import "./SendCVBlock.css";

const HIRING_EMAIL = "careers@realanbatiment.com";

function SendCV({ heading, description, submitButtonText }) {
  return (
    <section className="block sendcv">

      <h2>{heading || ''}</h2>

      <p>
        {description || ''}
      </p>

      <div className="sendcv-actions">
        <a
          href={`mailto:${HIRING_EMAIL}?subject=${encodeURIComponent('General Application')}`}
          className="sendcv-apply-link"
        >
          {submitButtonText || 'Send Application'}
        </a>
      </div>

    </section>
  );
}

export default SendCV;
